module.exports = __webpack_public_path__ + "img/ResidentialPickup.3be969fd.svg";